import script from "./PavilionMap.vue?vue&type=script&setup=true&lang=js"
export * from "./PavilionMap.vue?vue&type=script&setup=true&lang=js"

import "./PavilionMap.vue?vue&type=style&index=0&id=58d0d171&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58d0d171"]])

export default __exports__